import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getNavigationSearchType, getNavigationSearchValue } from 'selectors/shared/navigation'
import { getPageParamsQuery } from 'selectors/page'

const mapStateToProps = createStructuredSelector({
  searchType: getNavigationSearchType,
  searchValue: getNavigationSearchValue,
  // Initial Search Value
  searchQuery: getPageParamsQuery, // Clientside Page Transitions
})

export type ConnectorProps = {
  searchType: string
  searchValue: string
  searchQuery: string
}
export default connect(mapStateToProps, null, null, { forwardRef: true })
